export const profileThemes = [
  {
    id: 'memoir',
    name: 'Memoir',
    description: 'Warm paper, serif headings, and a book-like profile feel.',
    accentColor: '#8a5a34',
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Quiet, spacious, and clean for text-first profiles.',
    accentColor: '#3f4b5b',
  },
  {
    id: 'girly',
    name: 'Soft Bloom',
    description: 'Soft pinks, rounded cards, and a lighter diary mood.',
    accentColor: '#c05a87',
  },
  {
    id: 'fitness',
    name: 'Fitness',
    description: 'Fresh greens and punchy cards for habits, progress, and stats.',
    accentColor: '#287d52',
  },
  {
    id: 'gamer',
    name: 'Gamer',
    description: 'Dark neon contrast for games, sessions, ranks, and quests.',
    accentColor: '#7c4dff',
  },
  {
    id: 'creator',
    name: 'Creator',
    description: 'Gallery-like spacing for projects, experiments, and visual work.',
    accentColor: '#d06b2f',
  },
  {
    id: 'writer',
    name: 'Writer',
    description: 'Editorial typography for essays, stories, notes, and chapters.',
    accentColor: '#5a3f91',
  },
];

export function getProfileTheme(themeId) {
  return profileThemes.find((theme) => theme.id === themeId) || profileThemes[0];
}

export function profileThemeClass(themeId) {
  const theme = getProfileTheme(themeId);
  return `profile-theme-${theme.id}`;
}
